import React from 'react';
const globalAlloyContextsKeyName = '__AlloyContexts__';
/**
 * Retrieves a global context from `window.__AlloyContexts__` or creates one if it does not exist
 * @param name Context name (usually retrieved from CONTEXT_NAMES - globalContexts.ts:38)
 * @returns A new React.Context
 * @example
 * import { getOrCreateGlobalContext } from '@adsk/alloy-react-helpers';
 *
 * const ComponentContext = getOrCreateGlobalContext<ComponentContext>(CONTEXT_NAME);
 * @see DatePicker Notification
 */
export const getOrCreateGlobalContext = name => {
  const contexts = window[globalAlloyContextsKeyName] || {};
  if (!window[globalAlloyContextsKeyName]) {
    window[globalAlloyContextsKeyName] = contexts;
  }
  if (!contexts[name]) {
    contexts[name] = /*#__PURE__*/React.createContext(undefined);
  }
  return contexts[name];
};
export const getGlobalContext = name => {
  var _window$globalAlloyCo;
  return (_window$globalAlloyCo = window[globalAlloyContextsKeyName]) === null || _window$globalAlloyCo === void 0 ? void 0 : _window$globalAlloyCo[name];
};
export const CONTEXT_NAMES = {
  LocaleContext: 'LocaleContext',
  NotificationsContext: 'NotificationsContext',
  SuspenseContext: 'SuspenseContext'
};
//# sourceMappingURL=globalContexts.js.map